import { h } from "@stencil/core";
import { Question, Answers } from "../../api/publicApi/proactive-case-closure";

export interface QuestionRadioProps {
    question: Question;
    answers: Answers;
    setAnswers: (answers: Answers) => void;
    t: (key: string) => unknown;
    baseClass: string;
}

/**
 * functional stencil component for a question with radio buttons
 */
export function QuestionRadio({ question, answers, setAnswers, t, baseClass }: QuestionRadioProps) {
    return (
        <fieldset>
            <legend class="mf-proactive-case-closure__question">{t(question.labelKey)}</legend>
            <div class={`${baseClass}__radio-buttons-container`}>
                <div class={`${baseClass}__radio-buttons`}>
                    {Object.entries(question.options).map(([value, option]) => (
                        <ux-radio-button
                            key={value}
                            type="radio"
                            name={question.name}
                            value={value}
                            checked={answers[question.name] === value}
                            onUxRadioButtonChange={(
                                e: CustomEvent<{ name: string; value: string; inputId: string; checked: boolean }>
                            ) => {
                                setAnswers({
                                    ...answers,
                                    [question.name]: e.detail.value
                                });
                            }}
                        >
                            {t(option.labelKey)}
                        </ux-radio-button>
                    ))}
                </div>
            </div>
        </fieldset>
    );
}
